<template>
  <div class="content">
    <div
      class="chatContent"
      v-for="(item, index) in list"
      :key="index"
      @tap="cancel(item.uid)"
      v-show="list.length"
    >
      <div class="left">
        <image :src="item.avatar" mode=""></image>
      </div>
      <div class="middle">
        <div class="name">
          <span>{{ item.nickname }}</span>
        </div>
        <div class="neirong">
          <span>{{ item.log.msn }}</span>
        </div>
      </div>
      <div class="right">
        <div class="time">
          {{ item.log.day_time }}
        </div>
        <div class="board" v-if="item.no_read_num">
          {{ item.no_read_num }}
        </div>
      </div>
    </div>
    <div class="noMessage" v-show="!list.length">
      <img src="../../assets/images/noxiaoxi.jpg" mode=""></img>
    </div>
  </div>
</template>
<script>
import { chatList, chatMsnToRead } from "../../api/user";
export default {
  components: {},
  mounted() {
    let that = this;
    that.getList();
  },
  created() {
    let that = this;
    this.timer2 = setInterval(function() {
      that.getList();
    }, 1000);
  },
  data: function() {
    return {
      list: [],
      no_read: 0,
      timer2: ""
    };
  },
  methods: {
    getList() {
      chatList().then(res => {
        this.list = res.data.list;
        this.no_read = res.data.no_read;
      });
    },
    cancel(uid) {
      chatMsnToRead({
        to_uid: uid
      }).then(res => {
        console.log(res);
        this.getList();
		// this.$router.push()
      });
    }
  }
};
</script>

<style>
page {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.content {
  width: 100%;
  height: 100%;
}
.noMessage {
  width: 100%;
  height: 100%;
}
.noMessage img {
  width: 100%;
  height: 840rpx;
}
.chatContent {
  padding: 24rpx;
  display: flex;
}
.chatContent .left {
  border-radius: 100%;
}
.chatContent .middle {
  flex: 1;
  padding-left: 24rpx;
}
.chatContent .middle .name {
  color: #823813;
  height: 50rpx;
  line-height: 50rpx;
}
.chatContent .middle .neirong {
  color: #a7a7a7;
  height: 50rpx;
  line-height: 50rpx;
  max-width: 400rpx;
  overflow: hidden;
  span-overflow: ellipsis;
  white-space: nowrap;
}
.chatContent .right {
  position: relative;
}
.chatContent .right .time {
  color: #a7a7a7;
  font-size: 24rpx;
}
.chatContent .right .board {
  width: 34rpx;
  height: 34rpx;
  background-color: #f33c2b;
  border-radius: 100%;
  color: #ffffff;
  font-size: 24rpx;
  text-align: center;
  line-height: 34rpx;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 10rpx;
  margin: auto;
}
.chatContent .left img {
  width: 100rpx;
  height: 100rpx;
  border-radius: 100%;
}
</style>
